import { gql } from "graphql.macro";

export const buyersGuideCategoriesListQuery = gql`
  query buyersGuideCategoriesListQuery {
    buyersGuideCategories {
      id
      name
      parentId
      restrictToMembershipCategories
      insertedAt
      updatedAt
    }
  }
`;

export const buyersGuideCategoryQuery = gql`
  query buyersGuideCategoryQuery($categoryId: ID!) {
    buyersGuideCategory(categoryId: $categoryId) {
      id
      name
      parentId
      restrictToMembershipCategories
      insertedAt
      updatedAt
    }
  }
`;
